import { stringify } from 'qs';

import { CityCard } from 'components/Card';

interface City {
  city: string;
  state: string;
  inHouse: number;
  upcoming: number;
}

export const renderCityCards = (
  cities: City[],
  startIndex: number,
  endIndex: number,
  className?: string,
) => {
  return cities.slice(startIndex, endIndex).map((cityData, index) => (
    <CityCard
      key={`${cityData.city}, ${cityData.state}`}
      rank={startIndex + index + 1}
      className={className || 'min-h-[200px]'}
      city={cityData.city
        .toLowerCase()
        .replace(/(?:^|\s)\S/g, (a) => a.toUpperCase())}
      state={cityData.state.toUpperCase()}
      inHouse={cityData.inHouse}
      upcoming={cityData.upcoming}
      link={`/roster?filters=${encodeURIComponent(
        stringify({
          city: [`${cityData.city}`],
          state: cityData.state,
        }),
      )}`}
    />
  ));
};
